// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/SignIn/Handlers/SignInAsGuest";

export const XPopulateApiParameter: any = (props: any) => {
    const { session } = props.getState().context;

    const guestAccount: any = {
        isGuest: true,
        defaultFulfillmentMethod: session!.fulfillmentMethod,
    };

    if (session!.pickUpWarehouse) {
        guestAccount.defaultWarehouseId = session!.pickUpWarehouse.id;
    }

    guestAccount.properties = {
        ...guestAccount.properties,
        postalCode: window.localStorage.getItem("postalCode")!,
    };

    props.apiParameter = guestAccount;
};

replaceInChain(chain, PopulateApiParameter, XPopulateApiParameter);
